import { localisedValue } from "utils"

const occupationTransformer = (response, options = {}) => {
  return response.map(e => ({
    ...e,
    key: e.key,
    label: localisedValue({ object: e, key: "name" }),
    value: options?.useKey ? e.key : e.id.toString(),
    id: e.id,
  }))
}

export default occupationTransformer
